module.exports = __webpack_public_path__ + "img/CM-DJ-26-Nissan-Established.0d1002f4.jpg";